import React from 'react';
import PropTypes from 'prop-types';
import { Affix, Space, Form } from 'antd';
import styled from 'styled-components';

const AffixContent = styled.div`
  text-align: right;
  padding-top: 10px;
  padding-right: 10px;
`;

const AffixWrapper = styled(Affix)`
  .ant-affix {
    background: rgba(255, 255, 255, 0.75);
    filter: drop-shadow(1px -1px 3px #d4d4d4);
    height: 50px !important;
  }
`;

function FormItemSubmit({ children }) {
  return (
    <AffixWrapper offsetBottom={0}>
      <AffixContent>
        <Form.Item>
          <Space>{children}</Space>
        </Form.Item>
      </AffixContent>
    </AffixWrapper>
  );
}

FormItemSubmit.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormItemSubmit;
